<template>
<div class="quizier-module-container">
    <div class="block-title" v-if="has_title || block_type">
        <div class="h-numb number-list" v-if="(block_type == 'list' || block_type == 'rank') && list_number" :style="[bg_color? {'background-color': bg_color} : '']" :class="[block_class]">
          {{ list_number }}
        </div> 
        <div class="bulet bullet-list" v-if="block_type == 'bullet'" :style="[bg_color? {'background-color': bg_color} : '']"></div>
        <h3 class="title-txt" v-if="has_title">{{ has_title }}</h3>
        <div class="votebtn-cont rank-list" v-if="block_type == 'rank'">
            <a @click="vote_block" class="btn-down" :class="[has_voted()? 'voted' : '', downvoted()? 'has-votes' : '']" v-if="vote_down" data-action="down">
                <div class="loader"></div>
                <div class="txt-cont">
                    <!-- <i class="fa fa-caret-down" aria-hidden="true"></i> -->
                    <span v-html="svg('caret-down')"></span>
                    <div class="numb-cont">
                        <div class="numb">{{ down_votes }}</div>
                        <div class="btxt">{{ $tc('i18n.votes', down_votes) }}</div>
                    </div>
                </div>
            </a>
            <a @click="vote_block" class="btn-up" :class="[has_voted()? 'voted' : '', upvoted()? 'has-votes' : '']" data-action="up">
                <div class="loader"></div>
                <div class="txt-cont">
                    <!-- <i class="fa fa-caret-up" aria-hidden="true"></i> -->
                    <span v-html="svg('caret-up')"></span>
                    <div class="numb-cont">
                        <div class="numb">{{ up_votes }}</div>
                        <div class="btxt">{{ $tc('i18n.votes', up_votes) }}</div>
                    </div>
                </div>
            </a>
        </div>
        <div class="clearfix"></div>
    </div>
    <component :is="name" :index="index" :store="store" :displayLanguage="displayLanguage"></component>
    <div class="field description module-description" v-if="has_description" v-html="has_description"></div>
    <div class="in-article-advert mt-2" v-if="has_adsense">
        <InArticleAdsense :data-ad-client="$variables.adsense_publisher_id" :data-ad-slot="slot_id" />
    </div>
</div>
</template>

<script>
import axios from "axios"
import mixinComponent from '../mixins'

export default {
    props: ['name', 'index', 'displayLanguage'],
    mixins: [mixinComponent],
    data() {
        return {
            text_class: 'text-color-light',
            default_vote_down: false,
            slots: []
        }
    },
    computed: {
        has_adsense: function() {
            return this.$variables.enable_in_post_ads && 
                    this.$variables.adsense_publisher_id && 
                    this.slots.length != 0 &&
                    this.index % 2 == 0
        },
        slot_id: function() {
            return this.slots.length > 1? this.slots.shift() : this.slots[0]
        },
        list_number: function () {
            return this.has('counter', false)
        },
        has_title: function () {
            return this.has('title', false)
        },
        has_description: function () {
            return this.has('description')
        },
        block_type: function () {
            return this.has('block_type', false)
        },
        bg_color: function () {
            return this.has('block_colors.hex', false)
        },
        block_class: function () {
            return this.has('block_text_class', this.text_class)
        },
        vote_down: function () {
            return this.has('vote_down', this.default_vote_down)
        },
        up_votes: function () {
            return this.has_block('counts.up')
        },
        down_votes: function () {
            return this.has_block('counts.down')
        }
    },
    created() {
        this.slots = this.$variables.ads_slot_ids
    },
    methods: {
        has_voted: function () {
            return this.has_block('has_voted', false)
        },
        upvoted: function () {
            return this.has_block('has_upvoted', false)
        },
        downvoted: function () {
            return this.has_block('has_downvoted', false)
        },
        vote_block: function (e) {
            if (this.has_voted()) return

            let curTarget = e.currentTarget
            let $this = curTarget.dataset
            const url = this.$variables.ranking_url
            var action = {}
            action['action'] = $this.action
            action['index'] = this.has_block('index')
            action['post_id'] = this.post_id()
            action['url'] = url

            if (action['action'] == '' || !url) {
                Quizier.sweetError(this.$t('i18n.somethingWentWrong'))
                return false
            }

            axios.post(url, action).then(res => {
                if (res.data.reload) {
                    location.reload()
                }
                if (res.data.success) {
                    this._updateMe('has_voted', true)
                    this._updateMe('counts', res.data.action.counts)
                    // this.sortUpdate()
                }
            }).catch(err => {
                console.log('err from modcont', err)
                Quizier.sweetError(err.response.data.message)
                return false
            })
        },
    }
}
</script>
